import { APIComponentAttributes } from '@ardoq/api-types';
import { IconSize } from '@ardoq/icons';
import { ComponentRepresentation } from '@ardoq/basic-components';
import { EnhancedScopeData } from '@ardoq/data-model';
import { enhancedScopeDataOperations } from '@ardoq/scope-data';

type ResolvedComponentIconProps = {
  component: APIComponentAttributes;
  scopeData: EnhancedScopeData;
  iconSize?: IconSize;
};

const ResolvedComponentIcon = ({
  component,
  scopeData,
  iconSize,
}: ResolvedComponentIconProps) => {
  const componentColor = enhancedScopeDataOperations.getComponentColor(
    scopeData,
    component._id
  );
  const componentRepresentationData =
    enhancedScopeDataOperations.getComponentRepresentationData(
      scopeData,
      component._id
    );

  const representationDataHasIcon =
    componentRepresentationData.icon.id !== 'none' ||
    componentRepresentationData.isImage ||
    componentRepresentationData.value;

  return representationDataHasIcon ? (
    <ComponentRepresentation
      {...componentRepresentationData}
      iconSize={iconSize}
      style={{ color: componentColor }}
    />
  ) : null;
};

export { ResolvedComponentIcon };
